/* Alias de recherche : le nom collé -> le nom réel.
 *
 * La recherche Shopify découpe sur la ponctuation : « AC/DC » devient les
 * jetons « ac » et « dc », et « acdc » ne correspond à aucun des deux. Mesuré
 * le 25/08/2026 : « ACDC » rendait 0 résultat pertinent, « AC/DC » en rendait 5.
 *
 * Les ACCENTS ne sont pas concernés — Shopify les gère déjà, « Tiesto » remonte
 * bien Tiësto. Seule la ponctuation INTERNE casse, celle qui colle deux
 * morceaux d'un même nom.
 *
 * Cette table ne touche AUCUN produit : pas de tag posé, donc pas de fiche
 * réécrite, donc aucun `lastmod` bougé. Elle se régénère depuis le catalogue.
 */
window.LMS_ALIAS = {
"80sgreatesthits": "80's Greatest Hits",
"aapferg": "A$AP Ferg",
"aapmob": "A$AP Mob",
"aaprocky": "A$AP Rocky",
"abquintanillaiiiyloskumbiakings": "A.B. Quintanilla III Y Los Kumbia Kings",
"absoul": "Ab-Soul",
"acdc": "AC/DC",
"adolescentsorquesta": "Adolescent's Orquesta",
"all4one": "All-4-One",
"alpha520": "Alpha 5.20",
"altj": "alt-J",
"annemarie": "Anne-Marie",
"anom": "An'Om",
"aura": "Au/Ra",
"bbjacques": "B.B. Jacques",
"bbking": "B.B. King",
"bbrave": "B-Brave",
"bearsden": "Bear's Den",
"bellodallas": "Bello&Dallas",
"benben": "Ben&Ben",
"benlonclesoul": "Ben L'Oncle Soul",
"bigaranx": "Biga*Ranx",
"blink182": "blink-182",
"bomfunkmcs": "Bomfunk MC's",
"booskap": "Booska-P",
"bright": "B-Right",
"brns": "BØRNS",
"buhi": "BU$HI",
"bwitched": "B*Witched",
"camron": "Cam'ron",
"ccmusicfactory": "C+C Music Factory",
"cecile": "Ce'cile",
"cheub": "Cheu-B",
"comacose": "Coma_Cose",
"cristinadavena": "Cristina D'Avena",
"dama": "D.a.M.A",
"dangelo": "D'Angelo",
"dargendamico": "Dargen D'Amico",
"dblockeurope": "D-Block Europe",
"ddouble": "D-Double",
"deco27": "DECO*27",
"deeelite": "Deee-Lite",
"desree": "Des'ree",
"destinyschild": "Destiny's Child",
"diams": "Diam's",
"dsturb": "D-Sturb",
"eagleeyecherry": "Eagle-Eye Cherry",
"eazye": "Eazy-E",
"emilieclairebarlow": "Emilie-Claire Barlow",
"emmaa": "Emma'a",
"exocbx": "EXO-CBX",
"exosc": "EXO-SC",
"exotago": "Ex-Otago",
"folies": "Folie's",
"fontainesdc": "Fontaines D.C.",
"fromis9": "fromis_9",
"gdragon": "G-DRAGON",
"gdtop": "GD&TOP",
"geazy": "G-Eazy",
"gigidagostino": "Gigi D'Agostino",
"gigidalessio": "Gigi D'Alessio",
"gunit": "G-Unit",
"haash": "HA-ASH",
"hers": "Her's",
"heusslenfoire": "Heuss L'enfoiré",
"idle": "i-dle",
"imwithher": "I’m With Her",
"indiaarie": "India.Arie",
"innossb": "Innoss'B",
"izone": "IZ*ONE",
"jamielee": "Jamie-Lee",
"jeanjacquesgoldman": "Jean-Jacques Goldman",
"jeanlouisaubert": "Jean-Louis Aubert",
"jeanmicheljarre": "Jean-Michel Jarre",
"jetseter": "Jetset'er",
"jhope": "j-hope",
"jitheprinceofny": "J.I the Prince of N.Y",
"jjcale": "J.J. Cale",
"jokair": "Jok'air",
"jorgeriveraherrans": "Jorge Rivera-Herrans",
"kanaboon": "KANA-BOON",
"kaseo": "Kase.O",
"kmaro": "K-Maro",
"knaan": "K'naan",
"kpazdelasierra": "K-Paz De La Sierra",
"ktrap": "K-Trap",
"lalgerino": "L'Algerino",
"lallemand": "L'Allemand",
"lamano19": "La Mano 1.9",
"lantidotelafamille": "L'Antidote LaFamille",
"lasalami": "L.A. Salami",
"leighanne": "Leigh-Anne",
"lepeupledelherbe": "Le Peuple de l'Herbe",
"liims": "Liim’s",
"limsadaulnay": "Limsa d'Aulnay",
"linmanuelmiranda": "Lin-Manuel Miranda",
"lofang": "Lo-Fang",
"lorchestracinematique": "L'orchestra Cinematique",
"lukesitalsingh": "Luke Sital-Singh",
"mariepaulebelle": "Marie-Paule Belle",
"mikewillmadeit": "Mike Will Made-It",
"mousk": "Mous-K",
"mrkitty": "Mr.Kitty",
"mssketa": "M¥SS KETA",
"natashastpier": "Natasha St-Pier",
"ndubz": "N-Dubz",
"negmarrons": "Neg'Marrons",
"nerd": "N.E.R.D",
"neyo": "Ne-Yo",
"nflying": "N.Flying",
"noelgallaghershighflyingbirds": "Noel Gallagher's High Flying Birds",
"nuest": "NU'EST",
"obros": "O'Bros",
"olivianewtonjohn": "Olivia Newton-John",
"oliviaobrien": "Olivia O'Brien",
"onze20": "Onze:20",
"otgenasis": "O.T. Genasis",
"ozone": "O-Zone",
"pablochille": "Pablo Chill-E",
"parttimefriends": "Part-Time Friends",
"pierrebourne": "Pi'erre Bourne",
"pinodangio": "Pino D'Angiò",
"plainwhitets": "Plain White T's",
"qefavelas": "Q.E Favelas",
"racionaismcs": "Racionais MC's",
"ragnboneman": "Rag'n'Bone Man",
"rais": "Ra'is",
"raksu": "Rak-Su",
"rimk": "Rim'K",
"rundmc": "Run-DMC",
"ryanoshaughnessy": "Ryan O'Shaughnessy",
"saltnpepa": "Salt-N-Pepa",
"sams": "Sam's",
"sarah": "SARA’H",
"screw": "S-Crew",
"sexiondassaut": "Sexion d'Assaut",
"sharonjonesthedapkings": "Sharon Jones & The Dap-Kings",
"shym": "Shy'm",
"sikk": "Sik-K",
"sinang": "Sinan-G",
"sineadoconnor": "Sinéad O'Connor",
"sirmixalot": "Sir Mix-A-Lot",
"skap": "Ska-P",
"sophieellisbextor": "Sophie Ellis-Bextor",
"soyoon": "So!YoON!",
"spion": "S-Pion",
"sprinoir": "S.Pri Noir",
"taku": "Ta-Ku",
"tara": "T-ara",
"tarekkiz": "Tarek K.I.Z",
"tatu": "t.A.T.u.",
"tayk": "Tay-K",
"tayronkwidans": "Tayron Kwidan's",
"theallamericanrejects": "The All-American Rejects",
"theb52s": "The B-52's",
"thedream": "THE-DREAM",
"thelas": "The La's",
"themowglis": "The Mowgli's",
"thenotoriousbig": "The Notorious B.I.G.",
"tlow": "T-low",
"tpain": "T-Pain",
"transsiberianorchestra": "Trans-Siberian Orchestra",
"tuneyards": "Tune-Yards",
"vins": "Vin's",
"whydontwe": "Why Don't We",
"william": "will.i.am",
"wutangclan": "Wu-Tang Clan",
"ybwasgood": "Yb Wasg'ood",
"youme": "You+Me",
"youngma": "Young M.A",
"youssefswatts": "Youssef Swatt's",
"zeynepbastk": "Zeynep Bastık",
"ziont": "Zion.T"
};
